/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timing_Sync_Compensation_LabelInputs */

const en_timing_sync_compensation_label = /** @type {(inputs: Timing_Sync_Compensation_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timing Mode Compensation`)
};

const fr_timing_sync_compensation_label = /** @type {(inputs: Timing_Sync_Compensation_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compensation du mode de minutage`)
};

const de_timing_sync_compensation_label = /** @type {(inputs: Timing_Sync_Compensation_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timing-Modus-Kompensation`)
};

const it_timing_sync_compensation_label = /** @type {(inputs: Timing_Sync_Compensation_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compensazione della modalità di temporizzazione`)
};

const ru_timing_sync_compensation_label = /** @type {(inputs: Timing_Sync_Compensation_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Компенсация режима синхронизации`)
};

const es_timing_sync_compensation_label = /** @type {(inputs: Timing_Sync_Compensation_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compensación del modo de temporización`)
};

const zh_cn2_timing_sync_compensation_label = /** @type {(inputs: Timing_Sync_Compensation_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`时序模式补偿`)
};

const ja_timing_sync_compensation_label = /** @type {(inputs: Timing_Sync_Compensation_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイミングモード補正`)
};

const hi_timing_sync_compensation_label = /** @type {(inputs: Timing_Sync_Compensation_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टाइमिंग मोड मुआवजा`)
};

const pt_pt2_timing_sync_compensation_label = /** @type {(inputs: Timing_Sync_Compensation_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compensação do Modo de Temporização`)
};

/**
* | output |
* | --- |
* | "Timing Mode Compensation" |
*
* @param {Timing_Sync_Compensation_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timing_sync_compensation_label = /** @type {((inputs?: Timing_Sync_Compensation_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timing_Sync_Compensation_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_timing_sync_compensation_label(inputs)
	if (locale === "de") return de_timing_sync_compensation_label(inputs)
	if (locale === "it") return it_timing_sync_compensation_label(inputs)
	if (locale === "ru") return ru_timing_sync_compensation_label(inputs)
	if (locale === "es") return es_timing_sync_compensation_label(inputs)
	if (locale === "zh-CN") return zh_cn2_timing_sync_compensation_label(inputs)
	if (locale === "ja") return ja_timing_sync_compensation_label(inputs)
	if (locale === "hi") return hi_timing_sync_compensation_label(inputs)
	if (locale === "pt-PT") return pt_pt2_timing_sync_compensation_label(inputs)
	return en_timing_sync_compensation_label(inputs)
});